<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Meus eventos'"
    [titleIcon]="'pi pi-calendar'"
    [subtitle]="'Visualize e gerencie seus eventos criados.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      { label: 'Meus eventos', icon: 'pi pi-calendar' },
    ]"></app-page-header>
  <ng-container>
    <div class="page-container">
      <div class="section-toggle">
        <mat-button-toggle-group [(value)]="sectionDisplay" [hideSingleSelectionIndicator]="true">
          <mat-button-toggle [value]="DISPLAY_SECTION_OPTIONS_ENUM.MY_EVENTS"> PRODUTOR </mat-button-toggle>
          <mat-button-toggle [value]="DISPLAY_SECTION_OPTIONS_ENUM.ASSIGNED_EVENTS"> COLABORADOR </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      @switch (sectionDisplay) {
        @case (DISPLAY_SECTION_OPTIONS_ENUM.MY_EVENTS) {
          <app-my-events-list-container />
        }
        @case (DISPLAY_SECTION_OPTIONS_ENUM.ASSIGNED_EVENTS) {
          <app-my-assigned-events-list-container />
        }
        @default {
          <p>Opção não reconhecida</p>
        }
      }
    </div>
  </ng-container>
</app-layout>
